import { render, staticRenderFns } from "./statusTag.vue?vue&type=template&id=376257f5"
import script from "./statusTag.vue?vue&type=script&lang=js"
export * from "./statusTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports